import React from 'react'
import { DropdownItemProps } from 'semantic-ui-react'

interface ContextType {
  options: Options
  filters: Filters
  count: Count
  intructionCount: instructionCount
  instructionCasesByState: InstructionCasesByState
  navigate(state: string): void
}

interface Options {
  category: DropdownItemProps[]
  caseType: DropdownItemProps[]
  client: DropdownItemProps[]
  tpa: DropdownItemProps[]
  states: DropdownItemProps[]
  districts: DropdownItemProps[]
  user: DropdownItemProps[]
  userRoles: DropdownItemProps[]
  hospital: DropdownItemProps[]
}

interface Filters {
  AllDistrictS: any
  reportee:any
  setReportee(reportee:any):void
  defaultCaseCategory: boolean
  setDefaultCaseCategory (caseCategory: boolean): void
  setDistrictOptions: any
  category: string
  setCategory(category: string): void
  caseType: string
  setCaseType(caseType: string): void
  state: string
  setState(state: string): void
  client: string
  setClient(client: string): void
  tpa: string
  setTpa(client: string): void
  states: string
  setStates(states: string): void

  district: string
  setDistrict(district: string): void
  user: string
  setUser(user: string): void
  userRole: string
  setUserRole(userRole: string): void
  hospital: string
  setHospital(hospital: string): void
  claimNumber: string
  setClaimNumber(claimNumber: string): void
  insuredName: string
  setInsuredName(insuredName: string): void
  doctorName: string
  setDoctorName(doctorName: string): void
  search: string
  setSearch(search: string): void
  from: string
  setFrom(from: string): void
  to: string
  setTo(to: string): void
  getByClosedDate: boolean
  setGetByClosedDate(getByClosedDate: boolean): void
  getReinvestigation: boolean
  setGetReinvestigation(getReinvestigation: boolean): void
  getPushback: boolean
  setPushback(getPushback: boolean): void
  onChange: any
  setHospitalSearch(hospitalSearch: string): void
  hospitalSearch: string
}

interface Count {
  initiated: string
  generated: string
  open: string
  reportwriting: string,
  pushbackCA: string,
  pushbackRW: string,
  fold: string
  checked: string
  close: string
  graded: string
  reinvestigate: string
}

interface instructionCount {
  initiated: string
  generated: string
  open: string
  reportwriting: string,
  pushbackCA: string,
  pushbackRW: string,
  fold: string
  checked: string
  close: string
  graded: string
  reinvestigate: string
}

interface InstructionCaseItem {
  _id: string
  claim_number?: string
  case_type_name?: string
  case_state?: string
  [key: string]: any
}

interface InstructionCasesByState {
  [state: string]: InstructionCaseItem[]
}

const Context = React.createContext({} as ContextType)
export default Context
